// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-1f9cdf16] {\n  max-height: calc(100vh - 380px) !important;\n}\n.category-wrapper[data-v-1f9cdf16] {\n  display: flex;\n  align-items: center;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  white-space: nowrap;\n}\n.category-marker[data-v-1f9cdf16] {\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  margin-right: 8px;\n  border-radius: 5px;\n}", ""]);
// Exports
module.exports = exports;
